import React, { useState } from 'react'
import "./experience.css"
import CountUp from 'react-countup';
// import { useEffect, useRef } from 'react';
// import gsap from "gsap"
import ScrollTrigger from 'react-scroll-trigger';
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { useGSAP } from "@gsap/react";
// gsap.registerPlugin(ScrollTrigger);
function Experience() {
        const [counter,setCounter]= useState(false)
    // const ref = useRef();
    // useEffect(() => {
    //     const el = ref.current;
        
    //     gsap.fromTo(el, {y:190}, 
    //       {
    //         y:.01, duration: 1.4,delay:.24stagger:3,
    //          scrollTrigger: {
    //                 trigger: el,
    //         }
    //     })
    // }, [])
  return (
    <ScrollTrigger onEnter={()=> setCounter(true) } onExit={()=>setCounter(false)}>
        <div className='experience_container'>
        <div className="experience_sub" >
            <div className="experience_box1 experience_box" >
                <img src="https://t4.ftcdn.net/jpg/04/91/76/63/360_F_491766301_yF6pxwvJnyY4I43PlU6zPEPoY5ZjJLEL.jpg" alt="" /><br />    
                <h1>
                {counter &&                 <CountUp start={-90} end={4} duration={4} delay={.4}/>}
                <span style={{color:"lightblue"}}>+</span></h1><br />
                <h2>Institute</h2>
            </div>
            <div className="experience_box2 experience_box" >
                <img src="https://previews.123rf.com/images/muslumstock/muslumstock1811/muslumstock181110351/112750415-teacher-icon-black-filled-vector-illustration-teacher-symbol-on-white-background-can-be-used-in-web.jpg" alt="" /><br />    
                <h1>
                {counter &&                 <CountUp start={0} end={150} duration={4} delay={.4}/>}
                <span style={{color:"lightblue"}}>+</span></h1><br />
                <h2>Faculties</h2>
            </div>
            <div className="experience_box3 experience_box" >
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3ujIGFpm3CPlD0Y8GM58caVZW0Q2ELAEvZh0uL6q-QkAXi_B9bO7GtUJEhiPGpuYc6tA&usqp=CAU" alt="" /><br />    
                <h1>
                {counter &&                 <CountUp start={0} end={400} duration={3.3} delay={.4}/>}
                <span style={{color:"lightblue"}}>+</span></h1><br />
                <h2>Student placed</h2>
            </div>
            <div className="experience_box4 experience_box" >
                <img src="https://img.freepik.com/free-vector/creative-computer-logo-template_23-2149201860.jpg" alt="" /><br />    
                <h1>
                {counter &&                 <CountUp start={110} end={12} duration={4} delay={.4}/>}
                <span style={{color:"lightblue"}}>+</span></h1><br />
                <h2>Computer labs</h2>
            </div>
            <div className="experience_box5 experience_box" >
                <img src="https://i.pinimg.com/736x/73/c5/81/73c58183417c1813b8d1b26f765fa2d9.jpg" alt="" /><br />    
                <h1>
                {counter &&                 <CountUp start={100} end={20} duration={4} delay={.4}/>}
                <span style={{color:"lightblue"}}>+</span></h1><br />
                <h2>Experience</h2>
            </div>
        </div>
    </div>
    </ScrollTrigger>
  )
}

export default Experience